import React from 'react';
import AssignmentMultiSelect from './AssignmentMultiSelect';

const UserAreaAssignmentSelect = ({
  availableAreas,
  selectedAreaIds,
  onChange,
  isDisabled,
}) => (
  <AssignmentMultiSelect
    items={availableAreas}
    selectedIds={selectedAreaIds}
    onChange={onChange}
    isDisabled={isDisabled}
    name="assigned_areas"
  />
);

export default UserAreaAssignmentSelect;
